import { Button, Col, Popconfirm, Popover, QRCode, Row, Select, Space, Typography, message } from "antd";
import React, { useEffect, useState } from "react";
import PageHeader from "../../components/Elements/PageHeader";
import { QrcodeOutlined, TrademarkCircleFilled } from "@ant-design/icons";
import StandartTable from "../../components/Elements/StandartTable";
import { collection, deleteDoc, doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase/config";
import CreateSRoll from "./CreateSRoll";
import moment from "moment";
import EditSRoll from "./EditSRoll";
import { useCollection } from "../../hooks/useCollection";

const { Text, Link } = Typography;

export default function SRolls() {
   //data for materials select
   const { data: materialData, loading: materialLoading } = useCollection("secondWarehouse");

   const [rollsLoading, setRollsLoading] = useState(true);
   const [rollsData, setRollsData] = useState([]);
   const [searchMaterial, setSearchMaterial] = useState([]);

   //possibility to download qr code
   const downloadQRCode = () => {
      const canvas = document.getElementById("myqrcode")?.querySelector("canvas");
      if (canvas) {
         const url = canvas.toDataURL();
         const a = document.createElement("a");
         a.download = "QRCode.png";
         a.href = url;
         document.body.appendChild(a);
         a.click();
         document.body.removeChild(a);
      }
   };

   const handleSelectedSearch = (value) => {
      setSearchMaterial(value);
   };

   //popover content for qr code
   const qrContent = (value) => {
      return (
         <div id="myqrcode">
            <Space direction="vertical">
               <Button type="primary" block onClick={downloadQRCode}>
                  Download QR
               </Button>
               <h1>{value}</h1>
               <QRCode value={`https://managers-testing.web.app/materials/qr/${value}`} size={320} />
            </Space>
         </div>
      );
   };

   //default columns for table
   const rollsColumns = [
      {
         title: "Material",
         dataIndex: ["material", "material"],
         align: "center",
      },
      {
         title: "QR",
         align: "center",
         dataIndex: "id",
         render: (value) => (
            <>
               <Popover content={qrContent(value)} trigger="click">
                  <QrcodeOutlined />
               </Popover>
            </>
         ),
      },
      {
         title: "Meters",
         dataIndex: "remainingMeters",
         align: "center",
      },
      {
         title: "Width",
         dataIndex: "rollWidth",
         align: "center",
      },
      {
         title: "Comment",
         dataIndex: "comment",
         align: "center",
      },
      {
         title: "Last Used",
         dataIndex: "updated",
         align: "center",
         render: (value) => (
            <>
               <Text>{value?.seconds ? moment.unix(value.seconds).format("DD/MM/YYYY") : ""}</Text>
            </>
         ),
      },

      {
         title: "Created",
         dataIndex: "created",
         align: "center",
         render: (value) => (
            <>
               <Text>{value?.seconds ? moment.unix(value.seconds).format("DD/MM/YYYY") : ""}</Text>
            </>
         ),
      },

      {
         title: "Action",
         align: "center",
         render: (value) => (
            <>
               <Space split>
                  <EditSRoll materialLoading={materialLoading} materialData={materialData} rollProp={value} />
                  <Popconfirm title="Are you sure？" placement="left" onConfirm={(event) => deleteRoll(event, value.id)} okText="Yes" cancelText="No">
                     <Link style={{ color: "red" }}>delete</Link>
                  </Popconfirm>
               </Space>
            </>
         ),
      },
   ];

   //Delete material
   const deleteRoll = async (e, docid) => {
      e.preventDefault();
      const ref = doc(db, "secondWarehouseRolls", docid);
      try {
         await deleteDoc(ref).then(() => {
            message.success("Deleted!");
         });
      } catch (err) {
         message.success(err.message);
      }
   };

   //loads table data from database
   useEffect(() => {
      setRollsLoading(true);
      const matRef = collection(db, "secondWarehouseRolls");
      const unsubscribe = onSnapshot(matRef, (snapshot) => {
         let results = [];
         snapshot.docs.forEach((doc) => {
            results.push({ ...doc.data(), id: doc.id });
         });
         if (searchMaterial && searchMaterial.length > 0) {
            results = results.filter((roll) => searchMaterial.includes(roll.material.id));
         }
         setRollsData(results);
         setRollsLoading(false);
      });
      return () => unsubscribe();
   }, [searchMaterial]);

   return (
      <div style={{ padding: 15 }}>
         <Row>
            <Col span={24}>
               <PageHeader text="Second Warehouse Rolls" icon={<TrademarkCircleFilled />} />
            </Col>
            <Col span={24}>
               <Space split>
                  <CreateSRoll materialData={materialData} materialLoading={materialLoading} />
                  <Select
                     mode="multiple"
                     allowClear
                     style={{
                        width: 200,
                     }}
                     placeholder="Please select"
                     onChange={handleSelectedSearch}
                     fieldNames={{ label: "material", value: "id" }}
                     options={materialData}
                  />
               </Space>
            </Col>
         </Row>
         <Row>
            <Col span={24}>
               <StandartTable data={rollsData} loading={rollsLoading} columns={rollsColumns} />
            </Col>
         </Row>
      </div>
   );
}
